import { useState, type ReactElement } from "react";
import { useParams } from "react-router";
import { SimulatorPanel } from "../../components/SimulatorPanel";

/*
 * Wraps a step route with the local test-drive panel. After a run the step is re-mounted (new key), so it reloads
 * everything from the server and shows exactly what was saved, no special refresh path per screen.
 */
export function SimulatedStep({
  pathway,
  children,
}: {
  pathway: "gig" | "finance";
  children: ReactElement;
}) {
  const step = Number(useParams().step);
  const [run, setRun] = useState(0);
  return (
    <>
      <SimulatorPanel
        pathway={pathway}
        step={step}
        done={false}
        onRan={() => setRun((n) => n + 1)}
      />
      <div key={`${pathway}-${step}-${run}`}>{children}</div>
    </>
  );
}
